import type { RouteRecordRaw } from "vue-router";

export const courseBookmarksRoutes: RouteRecordRaw[] = [
  {
    path: "/course_bookmarks",
    name: "course_bookmarks",
    component: () => import("./CourseBookmarkListPage.vue"),
    meta: {
      requiresAuth: true,
      title: "courseBookmark.title",
    },
  },
];
